module.exports = __webpack_public_path__ + "img/dobby.b69a6d9a.svg";